<template>
  <!-- 
    HACK!
    There are problems with this v-app-bar if you try using it normally in our weird usage (a second app bar below the app bar).
    First it is positionned over the global app bar, so we have to specify a "top" 64px.
    Second it is at the same z-index as the global app bar and it overlaps it shadow, so we have to specify a lower z-index (4).
    Third if there is an extension (two lines app bar) it has a weird effect of moving down the content of left/right panels, 
    so we need these extension-height=0px extended-app-bar and this.$el.lastChild.style.height hacks.
    Finally it has a weird effect of moving up the content of left/right panels, so we have to put one in every view 
    (with top 0px so it is displayed under the global app bar).
   -->
  <v-app-bar
      id="viewbar"
      app
      fixed
      :style="style"
      color="grey lighten-3"
      elevation="0"
      extension-height="0px"
      :class="prominent ? 'extended-app-bar' : ''"
  >
    <template #default>
      <slot name="default"></slot>
    </template>
    <template v-if="prominent" #extension>
      <slot name="extension-content"></slot>
    </template>
<!--    <template v-if="prominent" slot="extension" id="viewbar-extension">-->
<!--      <v-btn>coucou</v-btn>-->
<!--    </template>-->
  </v-app-bar>
</template>

<script>
export default {
  props: ["hidden", "prominent", "contentUnder"],
  mounted() {
    this.adjustSecondLineHeight()
  },
  watch: {
    prominent: function () {
      this.adjustSecondLineHeight()
    }
  },
  computed: {
    top() {
      return this.hidden ? "0px" : "64px"
    },
    style() {
      let style = `top: ${this.top}; z-index: 4;`;
      if (this.contentUnder)
        style += 'box-shadow: 0px 2px 5px -2px rgba(0, 0, 0, 0.2) !important;'
      return style
    }
  },
  methods: {
    adjustSecondLineHeight() {
      if (this.prominent) {
        // this timeout is yet another hack to make
        // sure it happens after vuetify is setting it to 0 (extension-height="0px")
        setTimeout(() => {
          this.$el.lastChild.style.height = "64px"
        }, 30)
      }
    },
  }
}
</script>

<style scoped>
.extended-app-bar {
  height: 128px !important;
}
</style>
